export default {
  hello: 'Hello ',
  createNewAccount: 'Create New Account',
  byClickingOnTheButtonBelow: 'by clicking the button below, you agree all Rasmal',
  createAccount: 'Create Account',
  youHaveAnAccount: 'You have an account ?',
  loginNow: 'Login Now',
};
